var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.304 12.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3862"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3551"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3285",
    d: "M13.088 1.944l-.443.567-.584.748-3.48 4.452-.029.037-2.487-1.945.029-.037 1.96-2.508.584-.748 1.963-2.511z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3286",
    d: "M7.903 8.577l-.057.015-2.483.671.051-2.572v-.059z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3861"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3287",
    d: "M13.957 2.618l-.507.648a1.243 1.243 0 011.106 1.235v5.519a1.244 1.244 0 01-1.242 1.242H1.99A1.244 1.244 0 01.748 10.02V4.501A1.244 1.244 0 011.99 3.259h4.668l.584-.748H1.99A1.992 1.992 0 000 4.501v5.519a1.992 1.992 0 001.99 1.99h11.324a1.992 1.992 0 001.99-1.99V4.501a1.993 1.993 0 00-1.347-1.883z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditData);
export default __webpack_public_path__ + "static/media/EditData.16851ae3.svg";
export { ForwardRef as ReactComponent };